// extracted by mini-css-extract-plugin
export default {"PageLoader":"nH4iNW6o","container":"cROt8J26","box":"l0wIborw","icon":"C4PijH1a"};
    if(module.hot) {
      // 1764331277271
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  